@if (!lockedWeeks) {
  @if (!article.disallow_delivery_planning) {

     @if (showOrBeforeOption && monthList.length && monthList[0][1]?.length && (article.stock_status > 2 || !article)) {
      <i class="info info-1 position-absolute material-icons" [ngbTooltip]=" 'PREFERRED_WEEK_SELECT_EXPLANATION' | translate"
                [autoClose]="false">info</i>
     }

    <select class="form-control border" (change)="selectWeek($event)">
      <!-- No default selection -->
      @if (showOrBeforeOption && monthList.length && monthList[0][1]?.length && (article.stock_status > 2 || !article)) {
        <option
        value="or_before" value="" selected disabled>{{ 'SELECT_WEEK' | translate }}</option>
      }
      <!-- "Or before" option for bicycles when enabled -->
      @if (showOrBeforeOption && monthList.length && monthList[0][1]?.length && (article.stock_status > 2 || !article)) {
        <option
          value="or_before"
          [selected]="orBeforeSelected">
          {{ 'PREFERRED_WEEK_OF_DELIVERY' | translate }}
        </option>
      }
      @for (weeks of monthList; track weeks; let m = $index) {
        @if (weeks.length && weeks[1].length) {
          <optgroup [label]="getMonthDescription(weeks[0])">
            @for (week of weeks[1]; track weekValue(i, week); let i = $index) {
              <option [value]="week.value"
                [selected]="(i == 0 && !deliveryWeek) && (m == 0 && !deliveryWeek) || (week.value === deliveryWeek)">
                {{week.text}} @if (i === 0 && m === 0 && hasAsapDelivery) {
                - {{'ASAP_DELIVERY'|translate}}
              }</option>
            }
          </optgroup>
        }
      }
    </select>
    <!-- Secondary dropdown when "or before" is selected -->
    @if (orBeforeSelected && orBeforeWeeksList.length && article.stock_status > 2) {
      <div class="d-flex align-items-center">
        <select
          class="form-control border mt-2"
          (change)="selectOrBeforeWeek($event)" style="position: relative; z-index: 9999;">
          <option value="" disabled [selected]="!selectedOrBeforeWeek">{{ 'SELECT_PREFERRED_WEEK' | translate }}</option>
          @for (week of orBeforeWeeksList; track week) {
            <option [value]="week.value" [selected]="week.value === selectedOrBeforeWeek">
              {{ week.text }}
            </option>
          }
        </select>
        <i class="info info-2 material-icons" [ngbTooltip]=" 'PREFERRED_WEEK_SELECT_OPEN_ORDERS' | translate"
                  [autoClose]="false">info</i>
                </div>
    }
  } @else {
    <span class="d-block mt-2" style="line-height: 1rem;">{{'DISALLOW_PLANNING' | translate}}</span>
  }
} @else {
  <span class="d-block mt-2">{{article | statusText:true}}</span>
}

